import axios from 'axios'
import qs from 'qs'
import config from "../config/index"
import Vue from "vue";
import uuid from "../utils/uuid";
let vue = new Vue();

export const baseUrl = config.baseUrl;//在config目录下配置

export function req(headers,config) {

    headers = {
        ...headers,
        'uuid':uuid(),
    };

    const req = axios.create({
        baseURL: baseUrl,
        headers: headers,
        timeout: 60000,
    });

    req.interceptors.response.use(function (response) {
        let respData = response.data;
        // if (respData.code === 401){
        //     vue.$tokenExpireModal.show();
        // }
        return Promise.resolve(respData);
    }, function (error) {
        vue.$message.error("系统出错了..");
        return Promise.reject(error.response);
    });
    return req(config)
}

//post get 请求
export function request(config) {
    let headers = {
        'Content-type': 'application/x-www-form-urlencoded;',
    };
    if (config.method === 'post') {
        config.data = qs.stringify(config.data)
    }
    return req(headers,config);
}

export function requestJSON(config) {
    let headers = {
      'Content-type': 'application/json;',
    };
    return req(headers, config);
};

//上传文件
export function uploadFile(config) {

    let headers = {
        'Content-type': 'multipart/form-data',
    };
    return req(headers,config);
}

export function POST(url,data) {
    return request({
        method: 'post',
        url: url,
        data: data
    })
}

export function EXPORT(url) {
  window.location.href = config.baseUrl + url;
}

export function UPLOAD(url,formData,onProgress) {
    return uploadFile({
        method: 'post',
        url: url,
        data: formData,
        onUploadProgress:onProgress
    })
}



// WEBPACK FOOTER //
// ./src/request/request.js